<template>
  <div id="app">
    <div class="outer" v-if="loading">
      <div class="middle">
        <div class="inner">
          <div class="sk-fading-circle">
            <div class="sk-circle1 sk-circle"></div>
            <div class="sk-circle2 sk-circle"></div>
            <div class="sk-circle3 sk-circle"></div>
            <div class="sk-circle4 sk-circle"></div>
            <div class="sk-circle5 sk-circle"></div>
            <div class="sk-circle6 sk-circle"></div>
            <div class="sk-circle7 sk-circle"></div>
            <div class="sk-circle8 sk-circle"></div>
            <div class="sk-circle9 sk-circle"></div>
            <div class="sk-circle10 sk-circle"></div>
            <div class="sk-circle11 sk-circle"></div>
            <div class="sk-circle12 sk-circle"></div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      loading: true
    }
  },
  created () {
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.loading = false
    })
  }
}
</script>

<style>
@font-face {
  font-family: Barlow Condensed;
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  src: local("Barlow Condensed Bold"), local("BarlowCondensed-Bold"),
    url(https://fonts.gstatic.com/s/barlowcondensed/v2/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3nWuZEC.woff2)
      format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1ea0-1ef9, U+20ab;
}

@font-face {
  font-family: Barlow Condensed;
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  src: local("Barlow Condensed Bold"), local("BarlowCondensed-Bold"),
    url(https://fonts.gstatic.com/s/barlowcondensed/v2/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3jWuZEC.woff2)
      format("woff2");
  unicode-range: U+0100-024f, U+0259, U+1e??, U+2020, U+20a0-20ab, U+20ad-20cf,
    U+2113, U+2c60-2c7f, U+a720-a7ff;
}

@font-face {
  font-family: Barlow Condensed;
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  src: local("Barlow Condensed Bold"), local("BarlowCondensed-Bold"),
    url(https://fonts.gstatic.com/s/barlowcondensed/v2/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3bWuQ.woff2)
      format("woff2");
  unicode-range: U+00??, U+0131, U+0152-0153, U+02bb-02bc, U+02c6, U+02da,
    U+02dc, U+2000-206f, U+2074, U+20ac, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+feff, U+fffd;
}

body {
  background-color: #000;
}

.outer {
  display: table;
  position: absolute;
  height: 99%;
  width: 99%;
}

#logorechts {
  position: relative;
  z-index: 110;
  text-align: left;
  width: 14%;
  float: right;
  top: 100px;
}

#logorechts img {
  width: 100%;
  height: auto;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-left: auto;
  margin-right: auto;
  width: 400px;
}

.sk-fading-circle {
  margin: 0 auto;
  width: 40px;
  height: 40px;
  position: relative;
}

.sk-fading-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sk-fading-circle .sk-circle:before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: red;
  border-radius: 100%;
  -webkit-animation: sk-circleFadeDelay 1.2s ease-in-out infinite both;
  animation: sk-circleFadeDelay 1.2s ease-in-out infinite both;
}

.sk-fading-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
  transform: rotate(30deg);
}

.sk-fading-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
  transform: rotate(60deg);
}

.sk-fading-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.sk-fading-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
  transform: rotate(120deg);
}

.sk-fading-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
  transform: rotate(150deg);
}

.sk-fading-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.sk-fading-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
  transform: rotate(210deg);
}

.sk-fading-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
  transform: rotate(240deg);
}

.sk-fading-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.sk-fading-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
  transform: rotate(300deg);
}

.sk-fading-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
  transform: rotate(330deg);
}

.sk-fading-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.sk-fading-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.sk-fading-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.sk-fading-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

.sk-fading-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}

.sk-fading-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}

.sk-fading-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}

.sk-fading-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}

.sk-fading-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}

.sk-fading-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}

.sk-fading-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}

@-webkit-keyframes sk-circleFadeDelay {
  0%,
  39%,
  to {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

@keyframes sk-circleFadeDelay {
  0%,
  39%,
  to {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

.player-rechts-overlay img {
  max-width: 50px;
  max-height: auto !important;
  position: relative !important;
  margin: 38% 0 0 10px !important;
}

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  width: 100%;
  height: 100vh;
}

.showCursor {
  cursor: pointer;
}

body {
  background: none transparent;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  margin: 0;
  padding: 0;
  width: 100%;
  top: 0;
  left: 0;
}

#background {
  top: 0;
  left: 0;
  position: absolute;
}

.imageContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.imageCenterer {
  width: 1920px;
  height: 100%;
  position: fixed;
  left: 50%;
  top: 0;
  margin-left: -960px;
}

.imageCenterer img {
  display: block;
  margin: 0 auto;
  height: 100%;
}

#platform {
  position: absolute;
  width: 58%;
  height: auto;
  top: 500px;
  z-index: 2;
  text-align: right;
  display: none;
}

#links {
  width: 60%;
  top: 20%;
  padding-left: 100px;
}

#links,
#sender {
   position: relative;
    height: 900px;
    float: left;
}

#sender {
  width: 85%;
  top: 10px;
  left: 10px;
}

.platform1 {
  color: red;
  border-color: red !important;
}

.wrapper {
  border-radius: 20px;
  border: 12px solid red;
  background-color: #000;
  overflow: hidden;
  width: 95%;
  height: 95%;
  position: absolute;
  top: 10px;
  left: 10px;
}

.wrapperEmbedRealtv {
  border-radius: 0px;
        border: 15px solid rgba(0,0,255,.5);
    background-color: #000;
    overflow: visible;
    width: 95%;
    height: 95%;
    position: absolute;
    top: 15px;
    left: 15px;
}
.wrapperzweirund {
    border-radius: 20px;
    border: 15px solid rgba(200,200,200,.5);
    background-color: transparent;
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
        top: -10px;
    left: -10px;
    z-index: 1000;
    pointer-events: none;
}
#verlauf {
  width: 20px;
  height: 250px;
  border-radius: 20px;
  border-style: solid;
  border-width: 5px;
  z-index: 100;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(red),
    to(rgba(255, 0, 0, 0))
  );
  background: linear-gradient(red, rgba(255, 0, 0, 0));
}

#player-rechts,
#verlauf {
  position: relative;
  overflow: hidden;
  float: left;
}

#player-rechts {
  width: 80%;
  height: auto;
  top: -20px;
  z-index: 4;
  border-radius: 20px;
  border: 9px solid red;
  background-color: #000;
}

.platform2 {
  color: grey;
  border-color: grey !important;
}

#player-links {
  position: relative;
  width: 85%;
  height: auto;
  top: 0;
  z-index: 2;
  text-align: left;
  float: left;
}

#player-links-overlay {
  position: absolute;
  z-index: 110;
  top: 0;
  left: 0;
  margin: 0 auto;
  overflow: hidden;
}

#player-links-overlay,
#player-links-overlay img {
  width: 100%;
  height: 100%;
}

#playimage {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background-color: transparent;
  z-index: 210;
}

#playimage,
#playimage img {
  position: absolute;
  top: 0;
  left: 0;
}

#playimage img {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  right: 0;
  bottom: 0;
}

#player-voll {
  position: relative;
  width: 100%;
  height: auto;
  top: 0;
  z-index: 2;
  text-align: left;
  float: left;
}

#player-oben-transition img {
  max-width: 100px;
  max-height: 100px;
  width: 10%;
  height: auto;
}

#player-oben-transition {
  position: absolute;
  z-index: 100;
  top: 0;
  left: 20px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.aspect-rechts {
  height: 0;
  padding-top: 56.25%;
  position: relative;
}

#full:-moz-full-screen {
  border: 0;
}

#full:fullscreen {
  border-radius: 20px;
  border: 0;
  background-color: #000;
  overflow: hidden;
  width: 98%;
  height: 98%;
  position: absolute;
  top: 10px;
  left: 10px;
}

#full:-webkit-full-screen {
  border-radius: 20px;
  border: 0;
  background-color: #000;
  overflow: hidden;
  width: 98%;
  height: 98%;
  position: absolute;
  top: 10px;
  left: 10px;
}

#full:-ms-fullscreen {
  border-radius: 20px;
  border: 0;
  background-color: #000;
  overflow: hidden;
  width: 98%;
  height: 98%;
  position: absolute;
  top: 10px;
  left: 10px;
}

#full:-moz-full-screen {
  border-radius: 20px;
  border: 0 solid red !important;
  background-color: #000;
  overflow: hidden;
  width: 98%;
  height: 98%;
  position: absolute;
  top: 10px;
  left: 10px;
}
iframe {
  width: 100%;
  height: 100%;
  border: none;
}

#control,
#control-voll {
  position: relative;
  width: 60px;
  top: 60px;
  text-align: center;
  float: left;
  z-index: 1;
  left: 15px;
}

#verlauf img {
  width: 100%;
  height: 100%;
}
.draggable-button {
  top: 150px;
  left: 10px;
  width: 29px;
  height: 29px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 4px 10px 1px rgba(255, 0, 0, 0.2);
  box-shadow: 0 4px 10px 1px rgba(255, 0, 0, 0.2);
  margin-left: 14%;
  cursor: pointer;
}

#glow-mute,
.draggable-button {
  position: relative;
  z-index: 110;
}

#glow-mute {
  width: 100%;
  height: auto;
  font-family: Barlow Condensed, sans-serif;
  font-size: 15pt;
  text-align: center;
  float: left;
  left: 5px;
  text-transform: uppercase;
}

.imageFrontpage,
.imageFullscreen,
.mutePng,
.unmutePng {
  width: 70%;
  height: auto;
  max-width: 50px;
  min-width: 20px;
}

#glow-full {
  position: relative;
  width: 100%;
  height: auto;
  z-index: 110;
  text-align: center;
  float: left;
}

.fade-enter-active,
.fade-leave-active {
  -webkit-transition: opacity 0.5s;
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#space,
.space {
  height: 10px;
  font-family: Barlow Condensed, sans-serif;
  font-size: 15pt;
}

#logo,
#space,
.space {
  position: relative;
  width: 100%;
  z-index: 110;
  text-align: center;
  float: left;
}

#logo {
  height: auto;
  left: 0;
}

#rechts0 {
  position: relative;
  width: 30%;
  height: auto;
  float: left;
  padding-right: 0;
  top: 0px;
}

#rechts1 {
  position: relative;
  width: 30%;
  height: auto;
  float: left;
  padding-right: 0;
  top: 80px;
}

#rechts2 {
  position: relative;
  width: 30%;
  height: auto;
  float: left;
  padding-right: 0;
  top: 110px;
}

#rechts3 {
  position: relative;
  width: 30%;
  height: auto;
  float: left;
  padding-right: 0;
  top: 150px;
}

#logo1 {
  height: 110px;
  top: 80px;
}

#logo1,
#sender-logo {
  position: relative;
  width: 100%;
  z-index: 2;
  text-align: left;
  float: left;
}

#sender-logo {
  height: auto;
  top: 20px;
}
.autor {
  top: -20px;
  z-index: 2;
}

.autor {
  position: relative;
  width: 80%;
  left: 110px;
  float: left;
  z-index: 2;
  font-family: Barlow Condensed, sans-serif;
  font-size: 30pt;
  line-height: 36pt;
  text-align: left;
}
.title {
  position: relative;
  width: 80%;
  left: 110px;
  float: left;
  z-index: 2;
  font-family: Barlow Condensed, sans-serif;
  font-size: 30pt;
  line-height: 36pt;
  text-align: left;
  min-height: 40px;
  bottom: 20px !important;
}

.title {
  bottom: 20px;
}

#sentence {
  position: relative;
  width: 86%;
  height: 60px;
  float: left;
  z-index: 2;
  font-family: Barlow Condensed, sans-serif;
  font-size: 20pt;
  text-align: left;
  display: none;
}

#autor-voll,
#title-voll {
  font-size: 3.5vw;
}

#autor-voll,
#sentence-voll,
#title-voll {
  position: relative;
  width: 90%;
  height: auto;
  z-index: 2;
  font-family: Barlow Condensed, sans-serif;
  top: 20px;
  float: left;
}

#sentence-voll {
  font-size: 2vw;
}

#player-rechts-standbild {
  z-index: 100;
}

#player-rechts-overlay,
#player-rechts-standbild {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

#player-rechts-overlay {
  z-index: 110;
  margin: 0 auto;
}

#player-rechts img {
  position: absolute;
  width: 100%;
  height: auto;
}

#player-rechts-overlay img {
  width: auto;
  height: auto;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.sender1 {
  display: inline;
}
.sender2,
.sender3 {
  display: none;
}

#tickerleiste {
  position: relative;
  width: 90%;
  height: 40px;
  top: 20px;
  border-radius: 20px;
  border-style: solid;
  border-width: 9px;
  z-index: 100;
  overflow: hidden;
  float: left;
}

.kopenhagen {
  background-color: white;
  padding-left: 5px;
  padding-right: 5px;
}

#kopenhagen-about {
  position: relative;
  width: 100%;
  top: 30px;
  float: left;
  text-align: right;
  font-family: Barlow Condensed, sans-serif;
  font-size: 25pt;
  line-height: 30pt;
}

#realty-v-about {
    position: relative;
    width: 100%;
    top: 50px;
    float: left;
    text-align: right;
    font-family: Barlow Condensed,sans-serif;
    font-size: 25pt;
    line-height: 30pt;
}

.kopenhagen-program {
  position: relative;
  width: 90%;
  height: 500px;
  float: left;
  top: -20px;
  z-index: 1;
  border-radius: 20px;
  border: 9px solid red;
  overflow: hidden;
}
@-webkit-keyframes ticker {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    visibility: visible;
  }
  to {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes ticker {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    visibility: visible;
  }
  to {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.ticker-wrap {
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 40px;
  padding-left: 100%;
}

.ticker {
  display: inline-block;
  white-space: nowrap;
  padding-right: 100%;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-name: ticker;
  animation-name: ticker;
  -webkit-animation-duration: 30s;
  animation-duration: 30s;
}

.ticker__item {
  display: inline-block;
  padding: 0 2rem;
  font-size: 20pt;
  font-family: Barlow Condensed, sans-serif;
}

#abstand {
  position: relative;
  width: 100%;
  height: 200px;
  z-index: 4;
  float: left;
}

#footer {
  position: fixed;
  width: 100%;
  height: 50px;
  bottom: 0;
  z-index: 20000;
}

#footer a {
  font-family: Barlow Condensed, sans-serif;
  font-size: 20pt;
  text-decoration: none;
}
.wrapper embed,
.wrapper iframe,
.wrapper object {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.wrapperEmbedRealtv embed,
.wrapperEmbedRealtv iframe,
.wrapperEmbedRealtv object {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.aspect {
  height: 0;
  padding-top: 56.25%;
  position: relative;
}

.centerText {
  width: 100%;
  height: 100%;
  background-color: #000;
  text-align: center;
  vertical-align: middle;
  line-height: 200px;
}

.footerLink {
  font-family: Barlow Condensed, sans-serif;
  font-size: 20pt;
  text-decoration: none;
}

#externFrame {
  border: 0;
  margin: 0;
}

#externFrame,
.scrollContainer {
  position: relative;
  z-index: 1000;
  background-color: hsla(0, 0%, 100%, 0.8);
}

.scrollContainer {
  /* max-height: 450px; */
  max-height: 450px;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
}
.scrollContainerKopenhagen {
  /* max-height: 450px; */
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
}

#programPage {
  position: fixed;
  top: 180px !important;
  left: 180px;
  width: 50% !important;
  height: 60% !important;
  z-index: 1000;
}

.divTableCellProgramDay {
  width: 70%;
  font-size: 25pt;
  line-height: 20pt;
  vertical-align: bottom;
  text-transform: uppercase;
  padding-bottom: 20px;
}

.divTableCellProgramDay,
.divTableCellProgramTime {
  height: auto;
  font-family: Barlow Condensed, sans-serif;
}

.divTableCellProgramTime {
  width: 10%;
  font-size: 15pt;
  line-height: 30pt;
  color: #000;
  text-align: right;
}

.divTableCellProgramImage {
  width: 15%;
  height: auto;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: top;
}

.divTableCellProgramAuthor {
  width: 70%;
  height: auto;
  font-size: 15pt;
  font-family: Barlow Condensed,sans-serif;
  line-height: 15pt;
  vertical-align: bottom;
}

.divTableCellProgramTitle {
  font-size: 15pt;
  line-height: 15pt;
}

.divTableCellProgramTitle,
.divTextProgram {
  font-family: Barlow Condensed, sans-serif;
  vertical-align: top;
}

.divTableCellArchivAuthor {
  width: 70%;
  height: auto;
  vertical-align: bottom;
}

.divTableCellArchivAuthor,
.divTableCellArchivTitle {
  font-size: 15pt;
  color: red;
  font-family: Barlow Condensed, sans-serif;
  line-height: 20pt;
}

.divTextArchiv {
  font-size: 12pt;
  line-height: 13pt;
  color: #000;
  font-family: Barlow Condensed, sans-serif;
  min-height: 80px;
  max-width: 80%;
}

.thumbnailBigArchiv,
.thumbnailBigProgram {
  width: 200px;
  height: auto;
}

.thumbnailBigArchiv {
  border-radius: 20px;
  border: 6px solid red;
  background-color: #000;
  overflow: hidden;
}

.thumbnailSmallProgram {
  width: 100%;
  height: auto;
  min-width: 80px;
  border-radius: 10px;
  border: 4px solid ;
  background-color: #000;
  overflow: hidden;
}

.divTextProgram {
  font-size: 15pt;
  line-height: 13pt;
  color: #000;
  min-height: 80px;
  max-width: 80%;
}

.divTableRowProgramRow3 {
  border-spacing: 100px;
}

.divTableRowLetters {
  font-family: Barlow Condensed, sans-serif;
  font-size: 19pt;
  color: #000;
}

.divTableRowLetters a {
  font-family: Barlow Condensed, sans-serif !important;
  font-size: 18pt !important;
  color: red;
}

@media screen and (orientation: portrait) {
  #verlauf {
    position: relative;
    width: 20px;
    height: 150px;
    border-radius: 20px;
    border-style: solid;
    border-width: 5px;
    z-index: 100;
    overflow: hidden;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    float: left;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(red),
      to(rgba(255, 0, 0, 0))
    );
    background: linear-gradient(red, rgba(255, 0, 0, 0));
  }

  .vue-slider-component {
    height: 150px !important;
  }

  #sender {
    position: relative;
    width: 80% !important;
    height: auto;
    top: 10px;
    left: 10px;
    float: left;
  }

  #player-voll {
    width: 90%;
  }
}

@media screen and (aspect-ratio: 16/10) {
  #verlauf {
    position: relative;
    width: 20px;
    height: 150px;
    border-radius: 20px;
    border-style: solid;
    border-width: 5px;
    z-index: 100;
    overflow: hidden;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    float: left;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(red),
      to(rgba(255, 0, 0, 0))
    );
    background: linear-gradient(red, rgba(255, 0, 0, 0));
  }
  .vue-slider-component {
    height: 150px !important;
  }

  #sender {
    position: relative;
    width: 80% !important;
    height: auto;
    top: 10px;
    left: 10px;
    float: left;
  }
}

@media screen and (max-width: 1100px) {
  #links {
    position: relative;
    width: 90%;
    height: auto;
    top: 50px;
    padding-left: 0;
    margin: 0 auto;
    float: none;
  }

  #verlauf {
    top: 0;
  }

  #rechts0 {
    position: absolute;
    width: 90%;
    left: 2%;
    top: 0;
    padding-right: 0;
    display: block;
    margin: 0 auto;
    float: none;
  }

  #control {
    width: 8%;
    top: 20px;
    left: 10px;
  }

  #control,
  #logo {
    position: relative;
    text-align: center;
    float: left;
  }

  #logo {
    width: 100%;
    height: auto;
    z-index: 110;
    left: 0;
  }

  #rechts1 {
    width: 70%;
    padding-left: 20%;
    padding-top: 30px;
    margin: 0 auto;
  }

  .sender2 {
    font-size: 20pt !important;
    min-height: 20px !important;
    padding-left: 0 !important;
    line-height: 18pt !important;
    display: inline;
    top: -50px;
  }

  #logo2 {
    position: relative;
    width: 100%;
    height: 60px;
    z-index: 2;
    text-align: right;
    float: left;
    top: 10px;
  }

  #rechts2 {
    width: 70%;
    padding-left: 20%;
    margin: 0 auto;
  }

  .sender3 {
    font-size: 20pt !important;
    min-height: 20px !important;
    padding-left: 0 !important;
    line-height: 18pt !important;
    display: inline;
    top: -50px;
  }

  #logo3 {
    position: relative;
    width: 100%;
    height: 60px;
    z-index: 2;
    text-align: right;
    float: left;
    top: 10px;
  }

  #rechts3 {
    width: 70%;
    padding-left: 20%;
    margin: 0 auto;
  }

  #player-links {
    position: relative;
    width: 85% !important;
    height: 50%;
  }
  #player-rechts {
    top: -60px;
  }

  .title {
    min-height: 40px;
    bottom: 20px !important;
    bottom: 20px;
    z-index: 1;
  }

  #sentence {
    display: none !important;
  }

  #abstand {
    position: relative;
    width: 100%;
    height: 400px;
    z-index: 1;
    float: left;
  }

  #programPage {
    position: fixed;
    top: 0 !important;
    left: 0;
    padding: 5%;
    width: 90% !important;
    height: 450px;
    z-index: 1000;
  }

  .thumbnailBigArchiv,
  .thumbnailBigProgram {
    width: 200px;
    height: auto;
  }

  .thumbnailBigArchiv {
    border-radius: 20px;
    border: 6px solid red;
    background-color: #000;
    overflow: hidden;
  }

  .divTableCellArchivAuthor {
    width: 70%;
    height: auto;
    vertical-align: bottom;
  }

  .divTableCellArchivAuthor,
  .divTableCellArchivTitle {
    font-size: 15pt;
    color: red;
    font-family: Barlow Condensed, sans-serif;
    line-height: 20pt;
  }

  .divTextArchiv {
    font-size: 12pt;
    line-height: 13pt;
    color: #000;
    font-family: Barlow Condensed, sans-serif;
    min-height: 80px;
    max-width: 80%;
  }

  #logorechts {
    position: relative;
    z-index: 110;
    text-align: left;
    width: 14%;
    float: right;
    top: 70px;
  }

  .footerLink {
    font-family: Barlow Condensed, sans-serif;
    font-size: 15pt;
    text-decoration: none;
  }
}

@media screen and (max-width: 430px) {
  .thumbnailBigArchiv,
  .thumbnailBigProgram {
    width: 100px;
    height: auto;
  }

  .thumbnailBigArchiv {
    border-radius: 20px;
    border: 6px solid red;
    background-color: #000;
    overflow: hidden;
  }
}
</style>
